import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Title from '../../components/common/Title';
import Back from '../../components/common/Back';
import Icon from '../../components/common/Icon';
import Card from '../../components/elements/Card';
import NotFound from '../../components/common/NotFound';
import { fetchUserInfo } from '../../utils';

const Page = () => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    // Answers are stored per language in the DB; ask for the user's current
    // locale and let the API fall back to English when it isn't translated.
    const lang = (i18n.language || 'en').slice(0, 2);
    fetchUserInfo(`/faq?lang=${lang}`, setData, setLoading, setError);
  }, [i18n.language]);

  const faq = data?.faq || [];

  return (
    <Base activeNav="home">
      <Back to="/home" />
      <Title>{t('frequentlyAskedQuestions')}</Title>

      {faq.length > 0 ? (
        <div className="faq-list mx-3">
          {faq.map((item) => {
            const open = openId === item.id;
            return (
              <Card key={item.id} mb="2" p="0" className="faq-item">
                <button
                  type="button"
                  className="faq-item__question d-flex align-items-center justify-content-between w-100 text-start border-0 bg-transparent"
                  style={{ padding: '1rem', fontWeight: 600 }}
                  aria-expanded={open}
                  onClick={() => setOpenId(open ? null : item.id)}
                >
                  <span>{item.question}</span>
                  <Icon name={open ? 'angle-up' : 'angle-down'} className="ms-2 flex-shrink-0" />
                </button>
                {open && (
                  <div
                    className="faq-item__answer"
                    style={{ padding: '0 1rem 1rem' }}
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                )}
              </Card>
            );
          })}
        </div>
      ) : (
        <NotFound translationKey="noFaq" loading={loading} />
      )}
    </Base>
  );
};

export default Page;
